import { createFileRoute } from '@tanstack/react-router'
import RunDetailsPage from '@/components/pages/RunDetailsPage/RunDetailsPage'

export const Route = createFileRoute('/$workspaceName/$environment/apps/$name/runs/$seq')({
  component: RunDetailRoute,
})

function RunDetailRoute() {
  return <RunDetailsPage />
}
